/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponentHealthInfo } from './providerComponentHealthInfo';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface ProviderComponentHealthElements { 
    /**
     * Org Id
     */
    org_id?: string;
    vcds_service_type?: VcdsServiceTypeEnum;
    /**
     * Component Id
     */
    component_id?: string;
    /**
     * Report time for component health
     */
    report_time?: Date;
    health?: ProviderComponentHealthInfo;
}
export namespace ProviderComponentHealthElements {
}


